import React from 'react';

// Muted counterpart to FeatureTile — same footprint so tiles line up on the grid
// but visually reads as "not yet included." No fetching, no navigation.
export default function UpsellTile({ title, icon, pitch }) {
  return (
    <div
      className="relative bg-gray-50 dark:bg-gray-900/40 rounded-xl border border-dashed border-gray-200 dark:border-gray-800 p-5 transition-colors"
      role="group"
      aria-label={`${title} — not enabled for this property`}
    >
      {/* header — muted icon badge */}
      <div className="flex items-center gap-3 mb-4">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-500">
          {icon}
        </div>
        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400">{title}</h3>
      </div>

      <div className="mb-4">
        <div className="inline-flex items-center gap-1.5 text-[11px] font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-full px-2 py-0.5">
          <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          Not enabled
        </div>
      </div>

      <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed min-h-[3rem]">
        {pitch}
      </p>

      <div className="mt-5 pt-3 border-t border-gray-100 dark:border-gray-800/70 text-[11px] text-gray-500 dark:text-gray-500">
        Contact your account manager to enable.
      </div>
    </div>
  );
}
